module.exports = __webpack_public_path__ + "img/slide-12.cd7d3915.jpg";